import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TagItem } from 'app/components/common/tag/tag.component';
import { DeleteModalComponent } from 'app/components/modal/deleteModal.component';
import { ModalComponent } from 'app/components/modal/modal.component';
import { ModalService } from 'app/services/modal.service';
import { DevicesListComponent } from 'app/views/devices/devicesList.component';
import { DeviceModel } from 'app/views/devices/models/device.model';

export enum DeleteGroupModalResult {
    Cancel = 'Cancel',
    OverrideDeviceSettings = 'OverrideDeviceSettings',
    KeepDeviceSettings = 'KeepDeviceSettings'
}

@Component({
    selector: 'psm-delete-group-modal',
    templateUrl: 'deleteGroupModal.component.html',
    styleUrls: ['deleteGroupModal.component.scss']
})

export class DeleteGroupModalComponent extends ModalComponent<DeleteGroupModalResult>  {
    public title: string = '';
    public content: string = '';

    public optionConfig: DeleteGroupModalResult = DeleteGroupModalResult.OverrideDeviceSettings;
    public deviceTags: TagItem[];

    constructor(modalService: ModalService, router: Router) {
        super(modalService, router);
    }

    public onDeleteAction() {
        this.close(this.optionConfig);
    }

    public onCloseClicked() {
        this.close(DeleteGroupModalResult.Cancel);
    }

    protected onNavigation() {
        this.close(DeleteGroupModalResult.Cancel);
    }
}



// WEBPACK FOOTER //
// ./src/app/views/devices/groups/deleteGroupModal.component.ts